import {IconCtaItem} from "../Data/IconCtaItem";
import {AnimalItem, ConservationStatusItem, SpeciesItem} from "../Data/AnimalItems";

export default class AnimalSponsorshipFetch {

    public static async fetchConservation(fetchBase : string, culture : string) : Promise<ConservationStatusItem[]>
    {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/animals/conservation-status`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const list = new Array<ConservationStatusItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                list.push(value);
            }
            // Return the populated map
            return list;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    public static async fetchSpecies(fetchBase : string, culture : string) : Promise<SpeciesItem[]>
    {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/animals/species`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const list = new Array<SpeciesItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                list.push(value);
            }
            // Return the populated map
            return list;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }
    
    /**
     * Retrieves a list of animals
     * @param fetchBase - the base domain of the call - maybe empty while testing locally
     * @param culture - the culture to call (e.g. "en-US")
     * @param q - Query the text
     * @param conservation - the key of the conservation status
     * @param species
     */
    public static async fetchAnimals(fetchBase : string, culture : string, q : string | null, conservation : string | null, species : string[] | null) : Promise<AnimalItem[]>
    {
        try {
            const urlCulture = encodeURIComponent(culture);
            const baseUrl = `${fetchBase}/api/${urlCulture}/animals`;
            const params = new URLSearchParams();
            if(q != null) params.set("q", q);
            if(conservation != null) params.set("conservation", conservation);
            if(species != null)
            {
                for(const speciesValue of species){
                    params.append("species[]", speciesValue);
                }
            }
            const response = await fetch(`${baseUrl}?${params.toString()}`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const list = new Array<AnimalItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                list.push(value);
            }
            // Return the populated map
            return list;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }
    
    /**
     * Fetch Icon CTAs
     * @param fetchBase - protocol and domain - may be empty when testing in the same environment
     * @param culture - en-US or any others supported
     */
    public static async fetchIconCtas(fetchBase : string, culture : string): Promise<Map<string, IconCtaItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/icon-ctas`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, IconCtaItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                const item = new IconCtaItem(value.fetchKey, value.imageUrl, value.imageHoverUrl, value.ctaText);
                map.set(item.fetchKey, item);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }
    
    public static async fetchDictionary(fetchBase : string, culture : string) : Promise<Map<string, string>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/dictionary?set=animalsponsorship`, {
                'credentials': 'include',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, string>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                map.set(key, value as string);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }

    }
}